"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const getPreviewCookie = require("./getPreviewCookie.cjs");
const getActiveRepositoryName = () => {
  const [, repositoryName] = decodeURIComponent(getPreviewCookie.getPreviewCookie() || "").match(/"([a-zA-Z0-9][-a-zA-Z0-9]{2,}[a-zA-Z0-9]).prismic.io"/) || [];
  return repositoryName;
};
exports.getActiveRepositoryName = getActiveRepositoryName;
//# sourceMappingURL=getActiveRepositoryName.cjs.map
